import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  // new actions
  JOB_SITE_DOCUMENTS_FETCH: createSagaAction('JOB_SITE_DOCUMENTS_FETCH'),

  // old actions
  JOB_SITE_DOCUMENTS_REFRESH: createSagaAction('JOB_SITE_DOCUMENTS_REFRESH'),

  JOB_SITE_DOCUMENTS_S3: createSagaAction('JOB_SITE_DOCUMENTS_S3'),

  JOB_SITE_DOCUMENT_FOLDER_CREATE: createSagaAction('JOB_SITE_DOCUMENT_FOLDER_CREATE'),
  JOB_SITE_DOCUMENT_FOLDER_UPDATE: createSagaAction('JOB_SITE_DOCUMENT_FOLDER_UPDATE'),
  JOB_SITE_DOCUMENT_FOLDER_DELETE: createSagaAction('JOB_SITE_DOCUMENT_FOLDER_DELETE'),

  JOB_SITE_DOCUMENT_CREATE: createSagaAction('JOB_SITE_DOCUMENT_CREATE'),
  JOB_SITE_DOCUMENT_UPDATE: createSagaAction('JOB_SITE_DOCUMENT_UPDATE'),
  JOB_SITE_DOCUMENT_DELETE: createSagaAction('JOB_SITE_DOCUMENT_DELETE'),

  UPLOAD_JOB_DOCUMENT_ATTACHMENT: createSagaAction('UPLOAD_JOB_DOCUMENT_ATTACHMENT')
}

// Action Creators
export const actions = {
  // new actions
  jobSiteDocumentsFetch: ({ jobId, folderId }) => ({
    type: constants.JOB_SITE_DOCUMENTS_FETCH.ACTION,
    jobId,
    folderId
  }),

  //
  jobSiteDocumentsRefresh: ({ jobId }) => ({
    type: constants.JOB_SITE_DOCUMENTS_REFRESH.ACTION,
    jobId
  }),

  jobSiteDocumentsS3: ({ folderId }) => ({
    type: constants.JOB_SITE_DOCUMENTS_S3.ACTION,
    folderId
  }),

  createJobSiteDocument: ({ jobId, content, file, filename, userId }) => ({
    type: constants.JOB_SITE_DOCUMENT_CREATE.ACTION,
    jobId,
    content,
    file,
    filename,
    userId
  }),

  updateJobSiteDocument: ({ jobId, description, attachmentId, folderId }) => ({
    type: constants.JOB_SITE_DOCUMENT_UPDATE.ACTION,
    jobId,
    description,
    attachmentId,
    folderId
  }),

  deleteJobSiteDocument: ({ jobId, attachmentId, folderId }) => ({
    type: constants.JOB_SITE_DOCUMENT_DELETE.ACTION,
    jobId,
    attachmentId,
    folderId
  }),

  createFolder: ({ name, parentId, jobId, folderId }) => ({
    type: constants.JOB_SITE_DOCUMENT_FOLDER_CREATE.ACTION,
    name,
    parentId,
    jobId,
    folderId
  }),

  updateFolder: ({ name, folderId, jobId, currentFolderId }) => ({
    type: constants.JOB_SITE_DOCUMENT_FOLDER_UPDATE.ACTION,
    name,
    folderId,
    jobId,
    currentFolderId
  }),

  deleteFolder: ({ folderId, jobId, currentFolderId }) => ({
    type: constants.JOB_SITE_DOCUMENT_FOLDER_DELETE.ACTION,
    folderId,
    jobId,
    currentFolderId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, jobId, folderId }) => ({
    type: constants.UPLOAD_JOB_DOCUMENT_ATTACHMENT.ACTION,
    formData,
    jobId,
    folderId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.JOB_SITE_DOCUMENTS_FETCH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_DOCUMENTS_FETCH.SUCCESS:
      return {
        ...state,
        loading: false,
        documentsAndFolders: action.payload
      }

    // ------
    case constants.JOB_SITE_DOCUMENTS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_DOCUMENTS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteDocuments: action.payload
      }

    case constants.JOB_SITE_DOCUMENTS_S3.ACTION:
      return { ...state, error: null, loadingS3: true }
    case constants.JOB_SITE_DOCUMENTS_S3.SUCCESS:
      return {
        ...state,
        jobSiteDocumentsS3: action.payload
      }

    case constants.JOB_SITE_DOCUMENTS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_DOCUMENT_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_DOCUMENT_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_DOCUMENT_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.JOB_SITE_DOCUMENT_FOLDER_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_DOCUMENT_FOLDER_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_DOCUMENT_FOLDER_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_JOB_DOCUMENT_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_JOB_DOCUMENT_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteDocumentActions.js